import ToastrAction from 'toastr/actions/ToastrAction'
import { getAuthorization, checkAuth, getJson } from 'utils/ActionUtils'
import i18n from 'simple-react-i18n'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import { isNil } from 'lodash'

const HelpAction = {
    createIssue: (body) => dispatch => {
        return fetch(ApplicationConf.cms.createIssue(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthorization() },
            body: JSON.stringify(body),
        })
            .then(checkAuth)
            .then(getJson)
            .then(json => {
                const response = JSON.parse(json[0])
                const show = json[1]

                if (isNil(response.message)) {
                    const { id } = response.issue
                    dispatch(ToastrAction.success(i18n.issueCreate))
                    return { success: true, id, show }
                }
                dispatch(ToastrAction.error(i18n.issueCreateError))
                throw new Error(i18n.issueCreateError)
            })
            .catch(e => {
                dispatch(LogAction.logError(`${i18n.issueCreateError} : ${e}`))
                dispatch(ToastrAction.error(i18n.issueCreateError))
            })
    },
}

export default HelpAction